// Adapted from @react-admin/ra-calendar@1.2.0 — see ../README.md
import type { DatesSetArg } from '@fullcalendar/core'
import { addMonths, set, subMonths } from 'date-fns'

/**
 * By default, return an interval of 3 months around now (1 month before, 2
 * months after) unless the user requires a larger interval.
 *
 * This minimizes queries while navigating.
 *
 * Deviation from the original: it used date-fns `add`/`sub`, which arrived in
 * 2.16 — the Enterprise package carried its own nested date-fns 2.28 to get
 * them. Resolved from this app the version is 2.8.1, where neither exists, so
 * this uses `addMonths`/`subMonths` instead. Same result, no version floor.
 *
 * Second deviation: the filter keys. The original emitted `start_gte`, which
 * ra-data-hasura no longer understands — it separates a column from its
 * operator with '@' ("start@_gte") and passes anything else through as a
 * (nested) column name, so Hasura rejected the query with
 * `field "start_gte" not found in type: 'appointments_bool_exp'` and the
 * calendar silently showed no events.
 */
export const getFilterValuesFromInterval = (
  dateInfo?: DatesSetArg,
  filterValues: any = {}
): any => {
  const now = set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
  const nowMinus1Month = subMonths(now, 1)
  const nowPlus2Months = addMonths(now, 2)

  return !dateInfo || (dateInfo.start > nowMinus1Month && dateInfo.end < nowPlus2Months)
    ? {
        ...filterValues,
        'start@_gte': nowMinus1Month.toISOString(),
        'start@_lte': nowPlus2Months.toISOString(),
      }
    : {
        ...filterValues,
        'start@_gte': dateInfo.startStr,
        'start@_lte': dateInfo.endStr,
      }
}
